interface AppErrorOptions {
  code?: number | null;
  domainCode?: string | null;
  domainMessage?: string | null;
}

export class AppError extends Error {
  code: number | null;
  domainCode: string | null;
  domainMessage: string | null;

  constructor(
    message: string,
    {
      code = null,
      domainCode = null,
      domainMessage = null, //some
    }: AppErrorOptions = {}
  ) {
    super(message);
    this.name = 'AppError';
    this.code = code;
    this.domainCode = domainCode;
    this.domainMessage = domainMessage;
  }
}
